import { amountFormat } from './amountFormat';

export interface TokenAmountFormatConfig {
  amount?: number;
  hideLabel?: boolean;
  hideAmount?: boolean;
  label?: string;
  isCollectible?: boolean;
}

export function tokenAmountFormat(
  config: TokenAmountFormatConfig = {},
): string {
  if (config.amount === undefined) return '';

  return `${
    config.hideAmount
      ? ''
      : amountFormat(config.amount, { isInteger: config.isCollectible })
  } ${(!config.hideLabel && config.label) || ''}`;
}
